export class StatisticDataDto {
  total: number;
  numberDocument: number;
  numberVideo: number;
  numberExposition: number;
}
